import { render, staticRenderFns } from "./assemble-add-or-update.vue?vue&type=template&id=4dadc296&scoped=true"
import script from "./assemble-add-or-update.vue?vue&type=script&lang=js"
export * from "./assemble-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./assemble-add-or-update.vue?vue&type=style&index=0&id=4dadc296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dadc296",
  null
  
)

export default component.exports